export var DeviceType;
(function (DeviceType) {
    DeviceType["ULTRA_WIDE"] = "ultraWide";
    DeviceType["WIDE_ANGLE"] = "wideAngle";
    DeviceType["TELEPHOTO"] = "telephoto";
    DeviceType["TRUE_DEPTH"] = "trueDepth";
    DeviceType["DUAL"] = "dual";
    DeviceType["DUAL_WIDE"] = "dualWide";
    DeviceType["TRIPLE"] = "triple";
})(DeviceType || (DeviceType = {}));
//# sourceMappingURL=definitions.js.map